/*
 *   Copyright 2022-2023 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
import { Param } from "./param";
export const CHART_TYPES = [
    'line', 'area', 'scatter', 'step-area', 'spline-area', 'spline', 'step', 'step-after', 'step-before',
    'annotation',
    'bar', 'bar-polar',
    'display',
    'image',
    'map',
    'gauge', 'linear-gauge', 'circle', 'compass',
    'pie',
    'doughnut',
    'rose',
    'tabular',
    'svg',
    'input:text', 'input:list', 'input:secret', 'input:autocomplete', 'input:chips', 'input:chips-autocomplete', 'input:slider', 'input:date', 'input:date-range', 'input:multi', 'input:multi-cb',
    'button', 'button:radio',
    'hidden',
    'calendar', 'heatmap',
    'profile',
    'boxplot',
    'dashboard', 'dashboard:flex', 'dashboard:scada'
];
export class MapParams {
}
export class Dataset {
}
export class Label {
}
export class Tile {
    constructor() {
        this.options = new Param();
    }
}
export class GTS {
}
export class DiscoveryEvent {
}
export class DataModel {
}
export class Dashboard {
    constructor() {
        this.type = 'dashboard';
        this.tiles = [];
        this.vars = {};
        this.cols = 12;
        this.cellHeight = 220;
        this.bgColor = '#fff';
        this.fontColor = '#000';
    }
}
export class ChartBounds {
    constructor() {
        this.tsmin = 0;
        this.tsmax = 0;
        this.msmin = '';
        this.msmax = '';
        this.marginLeft = 0;
    }
}
//# sourceMappingURL=types.js.map
